IfDesktopDirective.DIRECTIVE_NAME = 'ktIfDesktop';
export default function IfDesktopDirective() {
    return {
        multiElement: true,
        transclude: 'element',
        priority: 601,
        terminal: true,
        restrict: 'A',
        require: '^ktScreenDetection',
        link: ($scope, $element, $attr, screenDetectionCtrl, $transclude) => {
            screenDetectionCtrl.registerOnDesktop($scope, $element, $transclude);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/screen-detection/if-desktop-directive.js